module.exports = __webpack_public_path__ + "static/media/close-04.5f6800c7.svg";